/**
 * Đường dẫn của các trang.
 *
 * Gom vào một chỗ thay vì viết chuỗi tại nơi khai báo và nơi điều hướng. Chuỗi lặp ở hai chỗ là một
 * trong những lỗi im lặng nhất của giao diện đơn trang: nơi khai báo và nơi điều hướng dùng hai chuỗi
 * khác nhau, và người dùng bấm vào mục thực đơn rồi thấy trang trắng.
 *
 * Dùng tiếng Việt không dấu trong đường dẫn: người dùng có lúc phải đọc hoặc gửi đường dẫn cho nhau,
 * và một đường dẫn tiếng Việt dễ đọc hơn hẳn so với chuỗi mã hóa phần trăm.
 */
export const AppRoutes = {
  /** Trang chủ. */
  Home: '/',

  /** Đổi mật khẩu của chính mình. */
  ChangePassword: '/doi-mat-khau',

  /** Quản trị tài khoản người dùng. */
  UserAccount: '/quan-tri/tai-khoan',

  /** Quản trị vai trò và phân quyền. */
  Role: '/quan-tri/vai-tro',

  /** Danh mục đơn vị đo. */
  UnitOfMeasure: '/danh-muc/don-vi-do',

  /** Danh mục tiền tệ. */
  Currency: '/danh-muc/tien-te',

  /** Danh mục quốc gia. */
  Country: '/danh-muc/quoc-gia',

  /** Danh mục thuế suất. */
  TaxRate: '/danh-muc/thue-suat',

  /** Danh sách khách hàng. */
  Customer: '/khach-hang',

  /** Liên hệ khách để lại ở form trên website. Đoạn tĩnh nên được ưu tiên hơn khuôn chi tiết khách hàng. */
  ContactRequest: '/khach-hang/lien-he',

  /**
   * Chi tiết một khách hàng.
   *
   * Khai riêng phần khuôn có tham số để nơi khai báo tuyến đường dùng đúng chuỗi này, còn nơi điều
   * hướng ghép định danh vào sau đường dẫn danh sách. Hai chỗ dùng hai chuỗi khác nhau là lỗi im
   * lặng nhất của giao diện đơn trang.
   */
  CustomerDetailPattern: '/khach-hang/:customerId',

  /**
   * Cơ hội bán hàng.
   *
   * Đặt ở cấp cao nhất cạnh khách hàng, không nằm trong nhóm dự án: một cơ hội chưa phải dự án, và
   * gộp chung sẽ làm người dùng tưởng mọi thương vụ đều đã thành dự án.
   */
  Opportunity: '/co-hoi',

  /** Danh sách dự án. */
  Project: '/du-an',

  /** Bảng Kanban theo trạng thái dự án. */
  ProjectBoard: '/du-an/bang',

  /** Bảng phân bổ nguồn lực — ai đang quá tải. */
  ProjectWorkload: '/du-an/phan-bo',

  /**
   * Demo dự án — nội dung trang Dự án tiêu biểu trên website công ty.
   *
   * Nằm dưới /du-an như bảng tiến độ và phân bổ: đoạn "demo" là chữ cố định nên bộ định tuyến xếp nó
   * trước tuyến chi tiết dự án có tham số.
   */
  ShowcaseProject: '/du-an/demo',

  Blog: '/blog',

  BlogNew: '/blog/viet-bai',

  BlogPreview: '/blog/xem-truoc',

  BlogEditPattern: '/blog/:postId',

  /**
   * Chi tiết một dự án.
   *
   * Khai riêng phần khuôn có tham số, cùng lý do như chi tiết khách hàng.
   */
  ProjectDetailPattern: '/du-an/:projectId',

  /**
   * Cây công việc của một dự án.
   *
   * Trang riêng chứ không phải một thẻ trên trang chi tiết: cây công việc của một dự án có thể tới
   * vài trăm dòng, và đặt nó cạnh các thẻ khác sẽ làm cả hai đều khó đọc.
   */
  ProjectTaskPattern: '/du-an/:projectId/cong-viec',

  /**
   * Công việc được giao cho chính mình.
   *
   * Đặt ở cấp cao nhất chứ không nằm trong một dự án cụ thể: đây là màn hình người làm mở ĐẦU TIÊN
   * trong ngày, và câu hỏi của họ là "hôm nay tôi làm gì" chứ không phải "dự án này còn việc gì".
   */
  MyTasks: '/viec-cua-toi',

  /** Danh mục loại dự án. */
  ProjectType: '/danh-muc/loai-du-an',

  /**
   * Danh sách mẫu dự án.
   *
   * Nằm ở cấp cao nhất chứ không nằm trong danh mục: mẫu dự án là quy trình chuẩn của công ty, và
   * người mở nó là người lập kế hoạch chứ không phải người khai danh mục.
   */
  ProjectTemplate: '/mau-du-an',

  /**
   * Cây công việc của một mẫu.
   *
   * Trang riêng, cùng lý do như cây công việc của dự án: một mẫu đầy đủ có thể tới vài chục dòng kèm
   * danh sách kiểm, và đặt nó trong một cửa sổ bật lên sẽ không đọc được.
   */
  ProjectTemplateDetailPattern: '/mau-du-an/:templateId',
} as const;
